<!-- eslint-disable -->
<template lang="pug">
    .olympiad-create__block
        .olympiad-create-form
            .olympiad-create-form__header
                .olympiad__group-setting
                    | {{ $i18n.t('router.router_editLevel') }}
                .olympiad-create-form__header-title(slot="title")
                    | {{ $i18n.t('olympiads.olympiads_editLevel_group') }}
                    =" "
                    span(v-text="+index + 1")
            stage-form.olympiad-create-form__stage(
                v-for="(stage, i) in stages",
                :stage-index="i",
                :stage="stage",
                :key="i",
                :games="games",
                @removeStage="removeStage",
                @upStage="upStage",
                @downStage="downStage"
            )
                template(v-if="olympiad.levels[index].isRealTime")
                    form-group(label="Время начала")
                        cs-input(
                            v-model="stage.startTime",
                            v-validate="'required|date_format:HH:mm' + getValidateRule(i)",
                            data-vv-as="'Время начала'",
                            :name="'stageStartTime' + i",
                            :disabled="!i"
                        )
                        help-text(slot="help-text", v-if="errors.has('stageStartTime' + i)", error) {{ errors.first('stageStartTime' + i) }}
                    form-group(label="Время конца")
                        cs-input(
                            v-model="stage.endTime",
                            v-validate="'required|date_format:HH:mm|after:' + stage.startTime",
                            data-vv-as="'Время конца'",
                            :name="'stageEndTime' + i"
                        )
                        help-text(slot="help-text", v-if="errors.has('stageEndTime' + i)", error) {{ errors.first('stageEndTime' + i) }}
            .olympiad-stage__block--center
                cs-button(
                    pattern="primary-outline",
                    color="blue",
                    @click="addStage"
                    narrow
                )
                    svg-icon(name="plus", middle)
                    |
                    | {{ $i18n.t('olympiads.olympiads_editLevel_addStage') }}
            divider
            .olympiad-stage__button-group
                cs-button.olympiad-stage__button(
                    pattern="primary-outline",
                    color="blue",
                    @click="$router.back()"
                )
                    | {{ $i18n.t('common.common_button_cancel') }}
                =" "
                cs-button.olympiad-stage__button(color="blue", @click="save") {{ $i18n.t('olympiads.olympiads_editLevel_save') }}
</template>

<script>
    /*eslint-disable*/
    import TrainerUtilities from '../../utils/trainer/trainer';
    import BoxHeader from '../../elements/BoxHeader.vue';
    import StageForm from './StageForm.vue';
    import defaultParameters from './config/level.json';
    import { mapState } from 'vuex';
    import _ from 'lodash';
    import stageTemplate from './config/stageTemplate.json';

    export default {
        mixins: [TrainerUtilities],
        props: {
            index: {
                type: [Number, String],
                default: 0,
            },
            olympiadId: {
                type: [Number, String],
                default: 0,
            },
        },
        created() {
            if (this.stage || this.olympiad) {
                this.level = this.olympiad.levels[+this.index];
                this.courseGames =
                    this.level.courses.length === 1 ? this.level.courses[0].games : defaultParameters.games;
                this.courseGames = this.courseGames.filter(game => {
                    return game.slug !== 'Shutter';
                });
                this.courseGames.forEach(game => {
                    if (game.slug === 'CatchWord') {
                        game.parameters.default.mode = 'interactive';
                    }
                    game.name = this.getGameName(game);
                    return game;
                });
                this.intermediateState = this.stage || _.cloneDeep(this.olympiad);
                this.stages = _.cloneDeep(this.intermediateState.levels[+this.index]['stages']);
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            } else {
                this.$router.push({ name: 'olympiads:create' });
            }
        },
        beforeRouteLeave(to, from, next) {
            let allowedPaths = ['olympiads:create', 'stage-game:edit', 'olympiads:edit'];
            if (to.name === 'olympiads:create' || to.name === 'olympiads:edit') {
                this.$store.dispatch('setIntermediateStage', null);
            }
            if (!allowedPaths.includes(to.name)) {
                this.$store.dispatch('setOlympiad', null);
                this.$store.dispatch('setIntermediateStage', null);
            }
            if (this.olympiadId) {
                to.params.olympiadId = this.olympiadId;
            }
            next();
        },
        watch: {
            stages: {
                handler(value) {
                    if (value) {
                        this.intermediateState.levels[+this.index]['stages'] = value;
                        this.$store.dispatch('setIntermediateStage', this.intermediateState);
                    }
                },
                immediate: true,
                deep: true,
            },
        },
        data() {
            return {
                stages: null,
                intermediateState: null,
                courseGames: null,
                level: null,
            };
        },
        computed: {
            ...mapState({
                olympiad: state => state.olympiad.olympiad,
                stage: state => state.olympiad.intermediateStage,
            }),
            games() {
                let games = _.cloneDeep(this.courseGames);
                games.forEach(game => (game.name = this.getGameName(game)));
                return games;
            },
            puzzlesAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'Puzzle') {
                            return !(game.parameters.default.games.length && game.parameters.default.image);
                        }
                        return false;
                    });
                });
            },
            anagramsAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'Anagrams') {
                            return !(
                                game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                            );
                        }
                        return false;
                    });
                });
            },
            wordsFieldIsIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'WordsField') {
                            return !(
                                game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                            );
                        }
                        return false;
                    });
                });
            },
            textsAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'Texts') {
                            return !game.parameters.default.sourceText;
                        }
                        return false;
                    });
                });
            },
            lettersFieldIsIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'LettersField') {
                            return !(
                                game.parameters.default.selectedLetters &&
                                game.parameters.default.selectedLetters.length
                            );
                        }
                        return false;
                    });
                });
            },
            catchWordIsIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'CatchWord') {
                            return !(
                                game.parameters.default.selectedGroups && game.parameters.default.selectedGroups.length
                            );
                        }
                        return false;
                    });
                });
            },
            punctuationMarksAreIncomplete() {
                return this.stages.some(stage => {
                    return stage.games.some(game => {
                        if (game.slug === 'PunctuationMarks') {
                            return !game.parameters.default.sourceText;
                        }
                        return false;
                    });
                });
            },
        },
        methods: {
            getValidateRule(index) {
                return index === 0
                    ? ''
                    : this.stages[index - 1].endTime
                    ? '|after:' + this.stages[index - 1].endTime
                    : '';
            },
            save() {
                if (!(this.games && !_.isEmpty(this.games))) {
                    this.$toasted.error(this.$i18n.t('homework.homework_create_noGamesError'));
                    return;
                }
                if (this.puzzlesAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_puzzle'),
                        })
                    );
                    return;
                }
                if (this.wordsFieldIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_wordsField'),
                        })
                    );
                    return;
                }
                if (this.anagramsAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_anagrams'),
                        })
                    );
                    return;
                }
                if (this.textsAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_texts'),
                        })
                    );
                    return;
                }
                if (this.lettersFieldIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_lettersField'),
                        })
                    );
                    return;
                }
                if (this.catchWordIsIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_catchWord'),
                        })
                    );
                    return;
                }
                if (this.punctuationMarksAreIncomplete) {
                    this.$toasted.error(
                        this.$i18n.t('homework.homework_create_noGameParameters', {
                            gameName: this.$i18n.t('common.common_gameName_punctuationMarks'),
                        })
                    );
                    return;
                }
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.intermediateState.levels[+this.index]['stages'].forEach((elem, index) => {
                            elem.position = index;
                        });
                        this.$store.dispatch('setOlympiad', this.intermediateState);
                        this.$router.back();
                    }
                });
            },
            addStage() {
                this.stages.push(_.cloneDeep(stageTemplate));
            },
            upStage(index) {
                if (index === 0) {
                    return;
                } else {
                    let origin = this.stages[index];
                    this.stages[index] = this.stages[index - 1];
                    this.$set(this.stages, index - 1, origin);
                }
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            },
            downStage(index) {
                if (index === this.stages.length - 1) {
                    return;
                } else {
                    let origin = this.stages[index];
                    this.stages[index] = this.stages[index + 1];
                    this.$set(this.stages, index + 1, origin);
                }
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            },
            removeStage(index) {
                this.stages.length > 1 && this.stages.splice(index, 1);
                this.level.isRealTime && (this.stages[0].startTime = this.level.startTime);
            },
        },
        components: {
            BoxHeader,
            StageForm,
        },
    };
</script>

<style lang="scss" scoped>
    .olympiad-create__block {
        background-color: $x-color-white;
        @include media($sm) {
            padding: 28px 30px;
            border-radius: 40px;
        }
    }
    .olympiad-create-form {
        margin: 0;
        padding: 10px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        box-sizing: border-box;
        border-radius: 20px;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 20px 50px;
        }
        @include media($xl) {
            padding: 50px 100px;
        }
    }

    .olympiad-create-form__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 35px;
        text-align: center;
    }

    .olympiad-create-form__header-title {
        font-size: 18px;
    }

    .olympiad-create-form__stage {
        border: 1px solid #bdbdbd;
        background-color: $x-color-white;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 10px;
    }

    .olympiad__group-setting {
        @include stack-space($space-large);
    }

    .olympiad-stage__block--center {
        margin-top: 20px;
        text-align: center;
        .cs-button--narrow {
            padding: 10px 30px !important;
            font-size: 16px !important;
            font-weight: 500 !important;
            .svg-icon {
                margin-right: 8px;
            }
        }
    }

    .olympiad-stage__button-group {
        text-align: right;
    }

    .olympiad-stage__button {
        @include media($sm) {
            margin-right: 20px;
        }
    }
</style>
